import React, { createContext, useState, useEffect, useContext } from 'react';


// Create the Email Context
const MemberProfileContext = createContext(null);

// Custom Hook to use the User Context
export const useMember = () => useContext(MemberProfileContext);


// Provider Component
export const MemberProfileProvider = ({ children }) => {
  const [personName, setPersonName] = useState('')
  const [memberships, setMemberships] = useState({});
  const [memberProfile, setMemberProfile] = useState({});
  const [eventTypes, setEventTypes] = useState([]);

  // Function to update individual fields dynamically
  const updateMember = (key, value) => {
    setMemberProfile((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <MemberProfileContext.Provider value={{ memberProfile, setMemberProfile, updateMember, personName, setPersonName,
      memberships, setMemberships, eventTypes, setEventTypes
     }}>
      {children}
    </MemberProfileContext.Provider>
  );  

}